import { useState } from 'react';
import { Loader2Icon } from 'lucide-react';
import ComponentContainer from '../../components/component-container/ComponentContainer';
import './styles.css';
import { Button } from '@/components/ui/button';
import { PinFields } from '@/components/pin-fields/pin-fields';
import { toast } from '@/components/toast/toast';
import notifyHB from '@/config/notifyHB';
import { PIN_REGEX, setPin } from '@/use-cases/set-pin';

export const PinSetup = () => {
	const [newPin, setNewPin] = useState('');
	const [pinConfirmation, setPinConfirmation] = useState('');
	const [isSaving, setIsSaving] = useState(false);

	const isValid = PIN_REGEX.test(newPin) && newPin === pinConfirmation;

	const handleSubmit = () => {
		if (!isValid) return;
		setIsSaving(true);
		setPin(newPin)
			.then(() => {
				setNewPin('');
				setPinConfirmation('');
				toast({
					mode: 'informative',
					description: 'PIN configurado con éxito',
				});
			})
			.catch((error) => {
				notifyHB('pin-setup', 'PinSetup', error);
				toast({
					mode: 'destructive',
					description:
						'No pudimos guardar tu PIN. Intenta de nuevo más tarde',
				});
			})
			.finally(() => {
				setIsSaving(false);
			});
	};

	return (
		<ComponentContainer>
			<h1>Configurar PIN</h1>
			<div className="cyber-spacer large" />
			<div className="pin-setup-body">
				<PinFields
					pin={newPin}
					setPin={setNewPin}
					pinConfirmation={pinConfirmation}
					setPinConfirmation={setPinConfirmation}
				/>
				<Button
					onClick={handleSubmit}
					disabled={!isValid || isSaving}
					variant="default"
				>
					{isSaving && <Loader2Icon className="animate-spin" />}
					Actualizar PIN
				</Button>
			</div>
		</ComponentContainer>
	);
};
